// extracted by mini-css-extract-plugin
module.exports = {"eventListItem":"event-list-module--event-list-item--1YddO","grid":"event-list-module--grid--3HVrf","events":"event-list-module--events--3jC_9"};